"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpaSettingsProvider = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var _1 = require(".");
var tpaSettingsProviderWarnShown = false;
var TpaSettingsProvider = function (_a) {
    var Wix = _a.Wix, editorSDK = _a.editorSDK, t = _a.t, experiments = _a.experiments, children = _a.children, publicData = _a.publicData, isMobile = _a.isMobile, isRTL = _a.isRTL, language = _a.language, revisionID = _a.revisionID, biConfig = _a.biConfig, componentRef = _a.componentRef, hostStyle = _a.hostStyle;
    // Checkf or editorSDK also
    var isWidgetMode = !Wix && publicData;
    if (isWidgetMode) {
        if (!tpaSettingsProviderWarnShown) {
            console.warn("Seems like you are using TPASettingsProvider to wrap a Widget.\nPlease, consider using TpaSettingsProviderForWidget to make tree-shaking work efficient.");
            tpaSettingsProviderWarnShown = true;
        }
        return (react_1.default.createElement(_1.TpaSettingsProviderForWidget, { hostStyle: hostStyle, publicData: publicData, isMobile: isMobile, isRTL: isRTL, language: language, t: t, experiments: experiments }, children));
    }
    // Render a provider for Settings mode
    return (react_1.default.createElement(_1.TpaSettingsProviderForSettings, { Wix: Wix, editorSDK: editorSDK, biConfig: biConfig, t: t, experiments: experiments, language: language, isRTL: isRTL, isMobile: isMobile, componentRef: componentRef, revisionID: revisionID }, children));
};
exports.TpaSettingsProvider = TpaSettingsProvider;
//# sourceMappingURL=TpaSettingsProvider.js.map